import Vue from 'vue'
import VueRouter from 'vue-router'
import Mine from '../views/Mine.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: () =>import ("../views/Report"),
        meta: {
            title: "成长报告",
            keepAlive:true
        }
    },
    {
        path: '/index',
        name: 'index',
        component: () =>import ("../views/Index"),
        meta: {
            title: "首页",
            keepAlive:true
        }
    },
    {
        path: '/mine',
        name: 'mine',
        component: Mine,
        meta: {
            title: "善合超脑"
        }
    },
    {
        path: '/login',
        name: 'login',
        component: () =>
            import ("../views/Login"),
        meta: {
            title: "登录"
        }
    },
    {
        path: '/userinfo',
        name: 'userinfo',
        component: () =>
            import ("../views/Userinfo"),
        meta: {
            title: "个人信息"
        }
    },
    {
        path: '/Ability',
        name: 'Ability',
        component: () =>
            import ("../views/Ability"),
        meta: {
            title: "能力树"
        }
    },
    {
        path: '/points',
        name: 'points',
        component: () =>
            import ("../views/Points"),
        meta: {
            title: "我的积分"
        }
    },
    {
        path: '/customTask',
        name: 'customTask',
        component: () =>
            import ("../views/CustomTask"),
        meta: {
            title: "定制任务"
        }
    },
    {
        path: '/report',
        name: 'report',
        component: () =>
            import ("../views/Report"),
        meta: {
            title: "成长报告"
        }
    },
    {
        path: '/taskList',
        name: 'taskList',
        component: () =>
            import ("../views/TaskList"),
        meta: {
            title: "任务列表"
        }
    },
    {
        path: '/clockin',
        name: 'clockin',
        component: () =>
            import ("../views/Clockin"),
        meta: {
            title: "任务打卡"
        }
    }, {
        path: '/record',
        name: 'record',
        component: () =>
            import ("../views/Record"),
        meta: {
            title: "购买积分记录"
        }
    }, {
        path: '/mywatch',
        name: 'mywatch',
        component: () =>
            import ("../views/Mywatch"),
        meta: {
            title: "我的手表"
        }
    }, {
        path: '/rankreward',
        name: 'rankreward',
        component: () =>
            import ("../views/RankReward"),
        meta: {
            title: "我的手表"
        }
    },
]

const router = new VueRouter({
    routes
})
export default router